export default function toPercent(floatValue) {
  return (floatValue * 100).toFixed(2).toString() + ' %';
}
